export default "__VITE_ASSET__CxSWPdCA__"